﻿import React, { useState, useEffect } from 'react';
import ColumnLogbookLookup from '../components/ColumnLogbookLookup';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import GlobalDialog from './Modal/GlobalDialog';
import { ColumnHeader } from '../models/column-header';
import { ColumnEntry } from '../models/column-entry';
import { ColumnData } from '../models/column-data';
import { FieldUpdate } from '../models/field-update';
import { NumberBoxComponent } from './NumberBoxComponent';
import { ItemBasicInformation } from '../models/item-basic-information';
import { ModalMetadata } from '../models/modal-metadata';
import { NewColumnEntryRequest } from '../models/new-column-entry-request';
import { ModalMessageType, BenchSheetTechnologyType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';

import NumberBox from 'devextreme-react/number-box';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

export interface Props {
    benchSheetId: string;
    technology: BenchSheetTechnologyType;
    readOnly?: boolean;
}

let key = 0;

export default function BenchSheetColumnInformation(props: Props) {
    const [columnData, setColumnData] =
        useState<ColumnData>();

    const [columnSearchDialogVisible, setColumnSearchDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        if (!dataLoaded)
            getAllData();
    }, []);

    key++;

    //const canEditRoles = ["SA", "QCBS-A", "QCBS-L", "QCBS-T"];
    //const canEdit = canEditRoles.some(r => this.props.user && this.props.user.roleCodes && this.props.user.roleCodes.includes(r));

    const columnHeader = columnData ? columnData.header : undefined;
    const columnEntry = columnData ? columnData.entry : undefined;

    return (
        <div>
            <div className="lq-header pw-margin-top-05">
                <div className="lq-header-title">Column Information</div>
                <div className="title-bar-spacer" />
                <div>
                    <Button className="title-bar-button"
                        text="" icon="info" type="success"
                        hint="item information"
                        onClick={showInformationDialog} />
                </div>
            </div>

            <div className="pw-form-section">
                <div className="pw-flex-wrapped-row-section">
                    <div className="column-information-left-pane">
                        <div className="pw-bordered-pane">
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Column ID</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.columnId ?
                                            columnHeader.columnId : 'NA'}</div>
                                </div>
                            </div>
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Column Brand</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.description ?
                                            columnHeader.description : 'NA'}</div>
                                </div>
                            </div>
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Column Dimensions</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.dimensions ?
                                            columnHeader.dimensions : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Column Max Temperature</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.maxTemperature ?
                                            columnHeader.maxTemperature + ' °C' : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Vendor Part Number</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.vendorPartNumber ?
                                            columnHeader.vendorPartNumber : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Vendor Serial Number</div>
                                    <div className="pw-readonly-label">{
                                        columnHeader && columnHeader.vendorSerialNumber ?
                                            columnHeader.vendorSerialNumber : 'NA'}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="pw-comp-row pw-margin-top-05">
                            <div className="pw-form-unit pw-comp-20">
                                <div className="pw-form-unit-label">Column Entry #</div>
                                <div className="pw-readonly-label">{columnEntry &&
                                    columnEntry.entryNumber ?
                                    columnEntry.entryNumber : 'NA'}</div>
                            </div>
                        </div>

                        <div className="pw-comp-row pw-margin-top-05">
                            {props.technology === BenchSheetTechnologyType.GasChromatography &&
                                <div className="pw-form-unit pw-comp-10">
                                    <label className="pw-form-unit-label">Number of Injections</label>
                                    <NumberBox id="runNumberOfInjections" readOnly={props.readOnly}
                                        placeholder="number of injections" format="#"
                                        onValueChanged={onRunNumberOfInjectionsValueChanged}
                                        value={columnEntry && columnEntry.runNumberOfInjections ?
                                            columnEntry.runNumberOfInjections : undefined} />
                                </div>
                            }

                            {props.technology === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                                <div className="pw-form-unit pw-comp-20">
                                    <label className="pw-form-unit-label">Compartment Temperature</label>
                                    <NumberBoxComponent id="compartmentTemperature"
                                        fixedUnit='°C' format="#.#" readOnly={props.readOnly}
                                        placeholder="compartment temperature"
                                        onValueChanged={onColumnEntryValueChanged}
                                        value={columnEntry && columnEntry.compartmentTemperature ?
                                            columnEntry.compartmentTemperature : undefined} />
                                </div>
                            }
                        </div>

                        {props.technology === BenchSheetTechnologyType.GasChromatography &&
                            <>
                                <div className="pw-comp-row pw-margin-top-05">
                                    <div className="pw-form-unit pw-comp-20">
                                        <label className="pw-form-unit-label">Run Low Temperature</label>
                                        <NumberBoxComponent id="runLowTemperature"
                                            fixedUnit='°C' format="#.#" readOnly={props.readOnly}
                                            placeholder="run low temperature"
                                            onValueChanged={onColumnEntryValueChanged}
                                            value={columnEntry && columnEntry.runLowTemperature ?
                                                columnEntry.runLowTemperature : undefined} />
                                    </div>

                                    <div className="pw-form-unit pw-comp-20">
                                        <label className="pw-form-unit-label">Run High Temperature</label>
                                        <NumberBoxComponent id="runHighTemperature"
                                            fixedUnit='°C' format="#.#" readOnly={props.readOnly}
                                            placeholder="run high temperature"
                                            onValueChanged={onColumnEntryValueChanged}
                                            value={columnEntry && columnEntry.runHighTemperature ?
                                                columnEntry.runHighTemperature : undefined} />
                                    </div>
                                </div>

                                <div className="pw-comp-row">
                                    <div className="pw-form-unit pw-comp-20">
                                        <label className="pw-form-unit-label">Column Linear Velocity</label>
                                        <NumberBoxComponent id="linearVelocity"
                                            fixedUnit='cm/sec' readOnly={props.readOnly}
                                            onValueChanged={onColumnEntryValueChanged}
                                            value={columnEntry && columnEntry.linearVelocity ? columnEntry.linearVelocity : undefined} />
                                    </div>

                                    <div className="pw-form-unit pw-comp-20">
                                        <label className="pw-form-unit-label">Column Flow Rate</label>
                                        <NumberBoxComponent id="flowRate"
                                            fixedUnit='mL/min' readOnly={props.readOnly}
                                            onValueChanged={onColumnEntryValueChanged}
                                            value={columnEntry && columnEntry.flowRate ? columnEntry.flowRate : undefined} />
                                    </div>
                                </div>
                            </>
                        }

                        <div className="pw-comp-row pw-margin-top-1">
                            <div className="pw-form-unit">
                                <Button onClick={showColumnSearchDialog} height="2rem"
                                    disabled={props.readOnly}
                                    text="Search Columns" icon="search" type="default" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DialogPopup visible={columnSearchDialogVisible}
                onHiding={hideColumnSearchDialog}
                title="Column Search"
                shading={true} shadingColor="#999999ab"
                hideOnOutsideClick={false}
                resizeEnabled={true}
                width='80vw'
                height='80vh'>

                <ColumnLogbookLookup technology={props.technology}
                    onCreateNewEntry={onCreateNewEntry}
                    onCancel={hideColumnSearchDialog} />
            </DialogPopup>

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width='25rem'
                    height='21rem'
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onCreateNewEntry(columnHeader: ColumnHeader) {
        createNewColumnEntry(columnHeader);
    }

    function showColumnSearchDialog(e: any) {
        setColumnSearchDialogVisible(true);
    }

    function hideColumnSearchDialog() {
        setColumnSearchDialogVisible(false);
    }

    function showInformationDialog() {
        if (columnEntry) {
            let itemBasicInitInformation: ItemBasicInformation = {
                rowPointer: columnEntry.columnEntryId,
                createTimestamp: columnEntry.createTimestamp,
                lastModifiedTimestamp: columnEntry.modifyTimestamp,
                createUser: columnEntry.createUser,
                modifyUser: columnEntry.modifyUser
            };

            setItemBasicInitInformation(itemBasicInitInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function onRunNumberOfInjectionsValueChanged(e: any) {
        if (e.element && e.element.id) {
            const propName = e.element.id;

            let columnDataEntry = { ...columnData.entry };

            columnDataEntry[propName] = e.value;

            setColumnData({ ...columnData, entry: columnDataEntry });

            let fieldUpdate: FieldUpdate = {
                field: propName,
                value: e.value,
                rowId: columnEntry.columnEntryId
            };

            await updateColumnEntry(fieldUpdate)
                .then(() => {
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Column Entry");
                });
        }
    }

    async function onColumnEntryValueChanged(e: any) {
        if (e.event && e.event.data && e.event.data.prop &&
            columnEntry && columnEntry.columnEntryId) {

            const propName = e.event.data.prop;

            let columnDataEntry = { ...columnData.entry };

            columnDataEntry[propName] = e.value;

            setColumnData({ ...columnData, entry: columnDataEntry });

            let fieldUpdate: FieldUpdate = {
                field: propName,
                value: e.value,
                rowId: columnEntry.columnEntryId
            };

            await updateColumnEntry(fieldUpdate)
                .then(() => {
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Column Entry");
                });
        }
    }

    /*
    async function useSelectedColumnEntry(columnHeaderId: string, columnEntryId: string) {
        if (props.benchSheetId && columnHeaderId && columnEntryId) {
            await updateColumnInformation(props.benchSheetId, columnHeaderId, columnEntryId)
                .then((data) => {
                    setColumnSearchDialogVisible(false);
                    getColumnData();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Column Information");
                });
        }
    }
    */

    async function createNewColumnEntry(columnHeader: ColumnHeader) {
        const request: NewColumnEntryRequest = {
            benchSheetId: props.benchSheetId,
            columnHeaderId: columnHeader.columnHeaderId
        };

        await insertColumnEntry(request)
            .then((data) => {
                setColumnSearchDialogVisible(false);
                getColumnData();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Column Entry");
            });
    }

    // GET functions

    async function getColumnData() {
        await CrudFunctions.getData(`benchsheets/columndata/${props.benchSheetId}`)
            .then(data => {
                setColumnData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Column Data");
            });
    }

    // POST functions

    async function insertColumnEntry(request: NewColumnEntryRequest) {
        return await CrudFunctions.postData("common/columnentry", request);
    }

    // PUT functions

    async function updateColumnEntry(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("common/columnentry", fieldUpdate);
    }

    /*
    async function updateColumnInformation(benchSheetId: string, columnHeaderId: string, columnEntryId: string) {
        const apiEntity = props.technology === BenchSheetTechnologyType.GasChromatography ? "gccolumninformation" : "gcrscolumninformation";

        return await CrudFunctions.putData(`benchsheets/${apiEntity}/${benchSheetId}/${columnHeaderId}/${columnEntryId}`, null);
    }
    */

    async function getAllData() {
        if (props.benchSheetId) {
            await getColumnData()
                .then(() => {
                    setDataLoaded(true);
                })
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
